import { Breadcrumb } from "antd"
import React, { useEffect, useState } from "react"
import { equalsIgnoreCase } from "../../../helpers/StringHelper"
import { updateProcessingDenominations } from "../../../networking/NetworkingBankNotes"
import { getStyle, notFilledInputClass, notFilledSelectClass, regularInputClass, regularSelectClass } from "../../../styles/styles"
import AlertBox from "../../shared/AlertBox"
import NumberInput from "../../shared/NumberInput"
import { formatToCurrency, formatToCurrencyWithScale } from "../../../helpers/FormatHelper"
import { useContext } from "react"
import PickAndPackContext from "./PickAndContext"
import { roundAmount } from "../../../helpers/BankNotesHelper"
import { getCurrentDateTime } from "../../../helpers/DateHelper"

const formatValidSelect = (valid) => {
    return valid ? regularSelectClass : notFilledSelectClass;
}
const formatValidInput = (valid) => {
    return valid ? regularInputClass : notFilledInputClass;
}

const style = getStyle();

const denominationRowStyles = {
  inputStyle: { width: "100px", textAlign: "right", fontSize: "1.1rem" },
  processingRow: {
    display: "flex",
    gap: "0",
    important: true,
    width: "100%",
  },
  processingRowlgt1: {
    display: "flex",
    gap: "0",
    important: true,
    width: "100%",
    marginTop: "1rem",
  },
  processingRowHeader: {
    textAlign: "right",    
    paddingRight: "0.5rem",
    backgroundColor: "inherit",
    height: "30px",
    lineHeight: "30px",
     minWidth: "70px",
    maxWidth: "90px",
  },
  processingRowHeaderCurrency: {
    textAlign: "right",
    fontSize: "1.2rem",
    paddingRight: "5rem",
    fontWeight: "bold",
  },
  processingRowCell: {
    minWidth: "60px",
    maxWidth: "100px",
    important: true,
    backgroundColor: "inherit",
    color: "inherit",
  },
  processingRowCellDisabled: {
    minWidth: "60px",
    maxWidth: "100px",
    important: true,    
    color: "inherit",
  },
  processingRowCellTotal: {
    important: true,
    minWidth: "60px",
    maxWidth: "150px",
    border: "0px",
    textAlign: "right",
    fontSize: "1.1rem",
    fontWeight: "600",
    backgroundColor: "inherit",
    color: "inherit",
  },
  dummyUkInput: {
    height: "30px",
  },
  rowSeparator: {
    color: "lightgray",
    height: "1px",
    important: true,
    width: "100%",
    marginTop: "1rem",
  },
};

const EditBnOrder = (props) => {

    const {
        lockedSide,
        bankNoteOrder,
        customerDenominations,
        lookUpTables,
        sellDeliveryStatusOptions,
        isBankNotesAdmin = false
    } = useContext(PickAndPackContext);

    let deliveryOptions = lookUpTables[equalsIgnoreCase(lockedSide, 'Buy') ? 'BNDeliveryBuyStatus' : 'BNDeliverySellStatus'] || []

    const sellSide = equalsIgnoreCase(lockedSide, 'sell')
    const showOrdered = sellSide || isBankNotesAdmin

    if (equalsIgnoreCase(lockedSide, "Sell") && Array.isArray(sellDeliveryStatusOptions) && sellDeliveryStatusOptions.length > 0) {
        deliveryOptions = deliveryOptions.filter(
            (d) =>
                Array.isArray(sellDeliveryStatusOptions) &&
                sellDeliveryStatusOptions.includes(d.value)
        );
    }

    const { orderNo, back, refreshSelectedOrder } = props

    const [deliveryStatus, setDeliveryStatus] = useState('')    
    const [customerId, setCustomerId] = useState(0)
    const [customerName, setCustomerName] = useState('')
    const [deliveryText, setDeliveryText] = useState('')

    const [saveMessageLabel] = useState('Save')    
    const [confirmSaveProcessedDenominations, setConfirmSaveProcessedDenominations] = useState({ show: false, title: '', message: '' })    

    const [alertMessage, setAlertMessage] = useState({ show: false, title: '', message: '' })

    const [validations, setValidations] = useState({ deliveryStatus: true })

    useEffect(() => {
        if (bankNoteOrder && bankNoteOrder.BNOrderNo > 0) {
            setDeliveryStatus(bankNoteOrder.DeliveryStatus)
            setCustomerId(bankNoteOrder.CustomerId)
            setCustomerName(bankNoteOrder.Name)
            setDeliveryText(bankNoteOrder.DeliveryText)
            bankNoteOrder.OrderRows.forEach(row => {
                let totalProcessed = 0;
                if (row.ProcessedDenominations) {
                    row.ProcessedDenominations.forEach(denomination => {
                        totalProcessed += denomination.NoNotesProcessed * parseInt(denomination.DenominationDescription, 10);
                    });
                }
                row.TotalProcessed = roundAmount(totalProcessed)
                row.TotalProcessedDiff = roundAmount(row.Amount - totalProcessed)
                row.TotalProcessedValid = row.TotalProcessed <= row.Amount

            })
            const currentUserId = localStorage.getItem('UserID');
            if (!equalsIgnoreCase(currentUserId, bankNoteOrder.UpdatedBy)) {
                setAlertMessage({
                    ...alertMessage, show: true, title: 'Warning',
                    message: 'The current order was previously modified by another user'
                })
            }
        }
    }, [bankNoteOrder])

    const validateDenominations = () => {
        const validateTotalProcessed = sellSide &&
            (equalsIgnoreCase(deliveryStatus, "completed") ||
                equalsIgnoreCase(deliveryStatus, "confirmed") ||
                equalsIgnoreCase(deliveryStatus, "in progress"));
        for (const row of bankNoteOrder.OrderRows) {
            if (validateTotalProcessed && row.TotalProcessed > row.Amount) {
                setAlertMessage({
                    ...alertMessage, show: true, title: 'Error',
                    message: (`The total processed amount ${formatToCurrencyWithScale(row.TotalProcessed, row.CurrencyID)} 
                    for the currency ${row.CurrencyName} cannot exceed the ordered amount ${formatToCurrencyWithScale(row.Amount, row.CurrencyID)}`)
                })
                return false
            }
            if (equalsIgnoreCase(deliveryStatus, 'completed') && row.TotalProcessed !== row.Amount) {
                setAlertMessage({
                    ...alertMessage, show: true, title: 'Error',
                    message: (`The total processed amount ${formatToCurrencyWithScale(row.TotalProcessed, row.CurrencyID)} 
                    for the currency ${row.CurrencyName} must match the ordered amount ${formatToCurrencyWithScale(row.Amount, row.CurrencyID)} 
                    to complete the order`)
                })
                return false
            }
            if (equalsIgnoreCase(deliveryStatus, "confirmed") && row.TotalProcessed === 0) {
                setAlertMessage({
                    ...alertMessage, show: true, title: 'Error',
                    message: (`The total processed amount ${formatToCurrencyWithScale(row.TotalProcessed, row.CurrencyID)} 
                    for the currency ${row.CurrencyName} must be greater than zero to confirm the order`)
                })
                return false
            }
        }
        return true
    }

    const onSaveProcessedDenominations = () => {
        let message
        if (equalsIgnoreCase(deliveryStatus, 'pending')) {
            message = `Do you want to save the order ${orderNo} as Pending?. It will change to zero all denominations?`
        } else if (equalsIgnoreCase(deliveryStatus, 'in progress') && !equalsIgnoreCase(bankNoteOrder.DeliveryStatus, 'In progress')) {
            message = `Are you sure you want to set the Order ${orderNo} as In Progress?`
        }
        else {
            message = `Are you sure you want to set the Order ${orderNo} as ${deliveryStatus}?`
        }

        if (equalsIgnoreCase(lockedSide, 'Buy') && equalsIgnoreCase(deliveryStatus, "confirmed")) {
            for (const row of bankNoteOrder.OrderRows) {
                if (row.TotalProcessed !== row.Amount) {
                    message = 'The total processed amount does not match the ordered amount, do you want to continue?'
                    break;
                }
            }
        }

        const pickAndPackCompleted = equalsIgnoreCase(deliveryStatus, 'completed')
        let validateForCompletion = pickAndPackCompleted && validateRequiredFields() && validateDenominations()

        if (pickAndPackCompleted && !validateForCompletion) {
            return
        }

        if (validateDenominations()) {
            setConfirmSaveProcessedDenominations({ ...confirmSaveProcessedDenominations, show: true, title: 'Confirm', message: message })
        }
    }

    const onConfirmSaveProcessedDenominations = async () => {
        closeConfirmSaveProcessedDenominations()
        bankNoteOrder.DeliveryStatus = deliveryStatus
        if (equalsIgnoreCase(lockedSide, 'Buy') && equalsIgnoreCase(deliveryStatus, "confirmed")) {
            bankNoteOrder.ReceivedOn = getCurrentDateTime()
        }

        const response = await updateProcessingDenominations(orderNo, bankNoteOrder, bankNoteOrder.UpdateToken)

        console.log('onConfirmSaveProcessedDenominations ', response)
        if (response !== undefined && response.success) {
            setAlertMessage({ ...alertMessage, show: true, title: 'Success', message: `Order ${orderNo} saved successfully` })
            refreshSelectedOrder()
            back()
        } else {
            setAlertMessage({
                ...alertMessage, show: true, title: 'Error',
                message: response !== undefined
                    ? response.Message
                    : 'Something went wrong. Please try again later.'
            })
        }
    }

    const closeConfirmSaveProcessedDenominations = () => {
        setConfirmSaveProcessedDenominations({ ...confirmSaveProcessedDenominations, show: false, title: '', message: '' })
    }
    

    const closeAlertMessage = () => {
        setAlertMessage({ ...alertMessage, show: false, title: '', message: '' })
    }

    const validateRequiredFields = () => {
        const currentValidations = updateAndGetValidations()
        return currentValidations.deliveryStatus
    }

    const updateAndGetValidations = (validateReferenceNo) => {
        const currentValidations = {
            ...validations,
            deliveryStatus: (deliveryStatus !== undefined && deliveryStatus !== null && deliveryStatus !== '' && deliveryStatus !== '-1')
        }
        setValidations(currentValidations)
        return currentValidations
    }

    const updateWorkingOrder = (rowNum, currencyId, denNum, denDesc, newValue) => {        
        const orderRow = bankNoteOrder.OrderRows.filter(r => r.ItemNo === rowNum && r.CurrencyID === currencyId)
        if (Array.isArray(orderRow) && orderRow[0].ItemNo > 0) {

            if (orderRow[0].ProcessedDenominations === undefined || orderRow[0].ProcessedDenominations === null) {
                orderRow[0].ProcessedDenominations = []
            }

            const processedDenomination = orderRow[0].ProcessedDenominations.filter(r => r.DenominationDescription === denDesc)            

            if (Array.isArray(processedDenomination) && processedDenomination.length > 0 && processedDenomination[0].ItemNo > 0) {
                processedDenomination[0].NoNotesProcessed = Number(newValue)
            }
            else {
                orderRow[0].ProcessedDenominations.push({
                    ItemNo: rowNum,
                    DenominationDescription: denDesc,
                    NoNotesProcessed: newValue
                })
            }

            let totalProcessed = 0;

            if (orderRow[0].ProcessedDenominations) {
                orderRow[0].ProcessedDenominations.forEach(denomination => {
                    totalProcessed += denomination.NoNotesProcessed * parseInt(denomination.DenominationDescription, 10);
                });
            }

            orderRow[0].TotalProcessed = roundAmount(totalProcessed)
            orderRow[0].TotalProcessedDiff = roundAmount(orderRow[0].Amount - totalProcessed)
            orderRow[0].TotalProcessedValid = orderRow[0].TotalProcessed <= orderRow[0].Amount
        }
    }

    const OrderRow = ({ orderRow, rowId }) => {

        const [refresh, setRefresh] = useState(false);

        let editDenominations = []
        let editDenominations2 = []

        let customerCurrencyDenominations = customerDenominations.filter(c => c.CurrencyID === orderRow.CurrencyID)

        if (Array.isArray(customerCurrencyDenominations) && customerCurrencyDenominations.length > 0 && Array.isArray(customerCurrencyDenominations[0].Denominations)) {

            editDenominations = customerCurrencyDenominations[0].Denominations.map((d, idx) => {

                let value = 0
                let orderedValue = 0
                if (orderRow.ProcessedDenominations) {

                    const processed = orderRow.ProcessedDenominations.filter(pd => pd.DenominationDescription === d.DenominationDescription)
                    if (Array.isArray(processed) && processed.length > 0) {
                        value = processed[0].NoNotesProcessed
                    }
                }
                if (orderRow.Denominations) {

                    const processed = orderRow.Denominations.filter(pd => pd.DenominationDescription === d.DenominationDescription)
                    if (Array.isArray(processed) && processed.length > 0) {
                        orderedValue = processed[0].NoNotes
                    }
                }
                else {
                    orderedValue = 0
                }
                return <div
                    id={`eo-div-details-rows-${rowId}-den-${idx}-root-${d.DenominationDescription}`}
                    key={`eo-div-details-rows-${rowId}-den-${idx}-root-${d.DenominationDescription}`}>
                    <div
                        id={`eo-div-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`}
                        key={`eo-div-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`}
                        style={denominationRowStyles.processingRowHeader}>
                        {d.DenominationDescription}</div>
                    {showOrdered && <div id={`eo-div-in-details-rows-${rowId}-den-${idx}-ordered-${d.DenominationDescription}`}
                        key={`eo-div-in-details-rows-${rowId}-den-${idx}-ordered-${d.DenominationDescription}`}
                    >
                        <NumberInput
                            id={`eo-in-details-rows-${rowId}-den-${idx}-ordered-${d.DenominationDescription}`}
                            key={`eo-in-details-rows-${rowId}-den-${idx}-ordered-${d.DenominationDescription}`}
                            className="uk-input"
                            type="Integer"
                            value={orderedValue === 0 ? '' : orderedValue}
                            onChange={() => { }}
                            disabled={true}
                            style={denominationRowStyles.processingRowCellDisabled}
                        />
                    </div>}

                    <div id={`eo-div-in-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`}
                        key={`eo-div-in-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`} >
                        <NumberInput
                            id={`eo-in-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`}
                            key={`eo-in-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`}
                            className="uk-input"
                            type="Integer"
                            value={value === 0 ? '' : value}
                            onChange={event => {
                                if (event.target.value === '' || event.target.value === null || event.target.value === undefined) {
                                    return;
                                }
                                updateWorkingOrder(orderRow.ItemNo, orderRow.CurrencyID, d.ItemNo, d.DenominationDescription, event.target.value)
                            }}
                            disabled={!equalsIgnoreCase(bankNoteOrder.DeliveryStatus, 'In progress')}
                            onBlur={() => {
                                setRefresh(refresh => !refresh)
                            }}
                            style={denominationRowStyles.processingRowCell}
                        />
                    </div>

                </div>
            })

            editDenominations.unshift(<div id={`eo-root-details-rows-${rowId}-den-indicator-edit`} key={`eo-root-details-rows-${rowId}-den-indicator-edit`} >
                <div style={denominationRowStyles.processingRowHeader}>&nbsp;</div>
                {showOrdered && <div style={denominationRowStyles.processingRowHeader}>{orderRow.Denominations ? 'Ordered' : 'Mixed Notes'}</div>}
                <div style={denominationRowStyles.processingRowHeader}>{sellSide ? 'Shipped' : 'Received'}</div>
            </div>);

            editDenominations.unshift(<div id={`eo-root-details-rows-${rowId}-den-indicatorcurrency-edit`} key={`eo-root-details-rows-${rowId}-den-indicatorcurrency-edit`} >
                <div style={denominationRowStyles.processingRowHeaderCurrency}>&nbsp;</div>
                <div style={denominationRowStyles.processingRowHeaderCurrency}>{orderRow.CurrencyID}</div>
                <div style={denominationRowStyles.processingRowHeaderCurrency}>&nbsp;</div>
            </div>);

            editDenominations2.push(
                <div id={`eo-root-details-rows-${rowId}-den-totalprocessed-edit`} key={`eo-root-details-rows-${rowId}-den-totalprocessed-edit`} >
                    <div
                        id={`eo-div-details-rows-${rowId}-den-totalprocessed-edit`} key={`eo-div-details-rows-${rowId}-den-totalprocessed-edit`}
                        style={denominationRowStyles.processingRowHeader}
                    >Total</div>
                    {showOrdered && <div>
                        <NumberInput
                            id={`eo-in-details-rows-${rowId}-den-totalordered-edit`} key={`eo-in-details-rows-${rowId}-den-totalordered-edit`}
                            className={formatValidInput(true)}
                            type="Currency"
                            value={formatToCurrency(orderRow.Amount || 0)}
                            disabled={true}
                            style={denominationRowStyles.processingRowCellTotal}
                        />
                    </div>}
                    <div>
                        <NumberInput
                            id={`eo-in-details-rows-${rowId}-den-totalprocessed-edit`} key={`eo-in-details-rows-${rowId}-den-totalprocessed-edit`}
                            className={formatValidInput(true)}
                            type="Currency"
                            value={formatToCurrency(orderRow.TotalProcessed || 0)}
                            disabled={true}
                            style={denominationRowStyles.processingRowCellTotal}
                        />
                    </div>
                </div>
            )

            showOrdered && editDenominations2.push(
                <div id={`eo-root-details-rows-${rowId}-den-totaldiff-edit`} key={`eo-root-details-rows-${rowId}-den-totaldiff-edit`} >
                    <div style={denominationRowStyles.processingRowHeader}>Difference</div>
                    <div style={denominationRowStyles.dummyUkInput}>&nbsp;</div>
                    <div>
                        <NumberInput
                            id={`eo-in-details-rows-${rowId}-den-totalprocessed-diff`} key={`eo-in-details-rows-${rowId}-den-totalprocessed-diff`}
                            className={formatValidInput(orderRow.TotalProcessedValid === undefined ? true : orderRow.TotalProcessedValid)}
                            type="Currency"
                            value={formatToCurrency(orderRow.TotalProcessedDiff || 0)}
                            disabled={true}
                            style={denominationRowStyles.processingRowCellTotal}
                        />
                    </div>
                </div>
            )


        }

        return <tr>
            <td><div style={rowId === 0 ? denominationRowStyles.processingRow : denominationRowStyles.processingRowlgt1}>
                {editDenominations}
            </div></td>

            <td><div style={rowId === 0 ? denominationRowStyles.processingRow : denominationRowStyles.processingRowlgt1}>
                {editDenominations2}
            </div></td>
        </tr>

    }

    const OrderRowsView = ({ order }) => {
        const orderRows = [];
        const denominationCount = order.OrderRows ? order.OrderRows.length : 0;
        if (order.OrderRows) {
            order.OrderRows.forEach((order, index) => {
                if (order) {
                    if (0 < index && index < denominationCount) {                        
                        orderRows.push(<tr>
                            <td colSpan={2}><hr key={`eo-hr-details-den-rows-${index}`} style={denominationRowStyles.rowSeparator} /></td>
                        </tr>)
                    }
                    orderRows.push(<OrderRow id={`eo-div-details-den-rows-${index}`} key={`eo-div-details-den-rows-${index}`}
                        orderRow={order} rowId={index} />)
                }
            })
        }
        return <div id='eo-div-details-rows' key='eo-div-details-rows' className="uk-grid" style={{display: "flex", justifyContent: "left", marginLeft: "10px"}}>
                <table>
                <tr>
                    <th></th>
                    <th></th>
                </tr>
                    {orderRows}
                </table>
            </div>;
    }

    return <div>
        <div className="breadcrumb-div">
            <Breadcrumb separator=">">
                <Breadcrumb.Item className={'breadcrumb-item'} onClick={back}>Orders - {equalsIgnoreCase(lockedSide, 'Sell') ? 'To shipped' : 'To receive'}</Breadcrumb.Item>
                <Breadcrumb.Item className="breadcrumb-item-bold">{`Order No. ${bankNoteOrder.BNOrderNo}`}</Breadcrumb.Item>
            </Breadcrumb>
        </div>
        <div>
            <div className="uk-grid uk-margin uk-width-1-2">
                <div className="uk-width-1-1">
                    <div className="uk-width-1-1">
                        <label className="uk-form-label" >Account</label></div>
                    <div className="uk-width-1-1" >
                        <input id='bo-in-customerid'
                            disabled
                            className="uk-input"
                            value={`${customerName} - ${customerId}`} />
                    </div>
                </div>

                {equalsIgnoreCase(lockedSide, "Sell") && <div className="uk-width-1-1">
                    <div className="uk-width-1-1">
                        <label className="uk-form-label" >Delivery To</label></div>
                    <div className="uk-width-1-1" >
                        <input id='bo-in-deliveryto'
                            disabled
                            className="uk-input"
                            value={deliveryText} />
                    </div>
                </div>}

                <div className="uk-width-1-1">
                    <div className="uk-width-1-1">
                        <label className="uk-form-label" >Delivery Status</label></div>
                    <div className="uk-form-controls">
                        <select id="bo-select-deliverystatus"
                            className={formatValidSelect(validations.deliveryStatus)}
                            value={deliveryStatus}
                            onChange={(e) => {
                                setDeliveryStatus(e.target.value);
                            }}                            
                        >
                            {deliveryOptions.map((type) => (
                                <option
                                    key={`status-option-${type.value}`}
                                    value={type.value}>{`${type.name}`}</option>
                            ))}

                        </select>
                    </div>
                </div>                
            </div>
            <div id='eo-div-details' key='eo-div-details'>
                <h3 style={style.subTitleStyle2} >Currencies - {lockedSide === 'Sell' ? 'We Sell' : 'We Buy'}</h3>
            </div>
            
            {bankNoteOrder && <OrderRowsView order={bankNoteOrder} />}            
            <hr />
            <div className="uk-width-1-2 uk-margin">
                <button id="eo-b-saveinprogress-order" className="uk-button uk-button-green" type="button"
                    onClick={onSaveProcessedDenominations}>{saveMessageLabel}</button>                
            </div>
        </div>        

        <AlertBox id="ab-warning-confirmSaveProcessedDenominations" open={confirmSaveProcessedDenominations.show} onClose={closeConfirmSaveProcessedDenominations}
            title={confirmSaveProcessedDenominations.title} message={confirmSaveProcessedDenominations.message} type="Yes/No"
            yesClick={onConfirmSaveProcessedDenominations} noClick={closeConfirmSaveProcessedDenominations} />        
        <AlertBox id="ab-alert-1" type="Ok" open={alertMessage.show} title={alertMessage.title} message={alertMessage.message}
            okClick={closeAlertMessage} onClose={closeAlertMessage} />

    </div>
}

export default EditBnOrder